import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        {/*<Auth0Provider
            domain={"dev-o4pvt29z.us.auth0.com"}
            clientId={"P52FOSuF82hBlngGgJR2ApyMNzc71q5a"}
            // redirectUri={"http://localhost:3400/home"}>
            redirectUri={"https://alaragreathouse.com/home"}>*/}
        <BrowserRouter>
            <App/>
        </BrowserRouter>
        {/*</Auth0Provider>*/}
    </React.StrictMode>
);
reportWebVitals();
